module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cpzjj"))).then(() => parcelRequire('iDabs'));